// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3Afj2","inputWrap":"CustomTip_inputWrap__2Jwj2"};